<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col sm="9">
          <h1>Курьеры</h1>
        </v-col>
        <v-col sm="3" class="search-col">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">
          <v-btn @click="importCouriers">
            Импортировать курьеров
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Пусто"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :search="search"
          :items="items"
          :options.sync="options"
          :footer-props="footerProps"
          show-select
          :items-per-page="-1"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :loading="loading"
          loading-text="Загрузка... Подождите пожалуйста"
      >
        <template v-slot:item.name="{item}">
          {{ item.display_name}}
        </template>
        <template v-slot:item.pay_link="{item}">
          <v-text-field outlined
                        v-model="item.pay_link"
                        dense

                        hide-details
                        @change="updatePayLink(item)">
          </v-text-field>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
        :z-index="4"
        :value="overlay"
    >
    </v-overlay>


    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        right
        top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
// @ is an alias to /src

import ProductService from './../../api/ProductService'
import CategoryService from './../../api/CategoryService'
import TagService from './../../api/TagService'
import SmsLogService from "@/api/SmsLogService";
import CourierService from "@/api/CourierService";

export default {
  name: 'SmsLogIndex',
  components: {},
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    overlay: false,
    loading: true,
    items: [],
    total: 0,
    timerId: null,
    search: '',
    options: {},
    footerProps: {
      itemsPerPageText: 'Элементов на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [-1]
    },
    headers: [
      {
        text: 'Код',
        value: 'code',
      },
      {
        text: 'ФИО',
        value: 'display_name',
        sortable: false
      },
      {
        text: 'Ссылка на платежную систему',
        value: 'pay_link',
        sortable: false,
        width: '50%'
      },

    ],
  }),
  mounted() {
    this.getDataFromApi()
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  methods: {
    updatePayLink(item){
      const params = {
        pay_link: item.pay_link
      }
      CourierService.updateCourier(item.id, params)
          .then(response => {
            this.snackbar = true;
            this.snackbarText = 'Ссылка сохранена';
            this.snackbarColor = 'success';
          })
    },
    importCouriers() {
      this.loading = true

      const params = {
        search: this.search,
      }

      CourierService.importCouriers()
        .then((response) => {
          CourierService.listCouriers(params)
            .then(response => {
              this.items = response.data

              this.loading = false
            })
        }).catch(() => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка импорта';
          this.snackbarColor = 'error';
      })
    },
    getDataFromApi() {
      this.loading = true

      const params = {
        search: this.search,
      }

      CourierService.listCouriers(params)
          .then(response => {
            this.items = response.data

            this.loading = false
            this.selected = []
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

span.v-btn {
  border-color: currentColor !important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }


  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
